import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(SplitText, ScrollTrigger);

/**
 * SVGのパスとテキストの点滅アニメーション クラス
 */
export default class Flickering {

    constructor() {
        this._init();
    }

    /**
     * SVGのパスをランダムなディレイでフェードインさせる
     */
    setupSvgFlickering(element) {
        const paths = element.querySelectorAll('path');

        paths.forEach(path => {
            this._animateElmFlicker(path);
        });
    }

    /**
     * プレーンテキストをSplitTextでランダムにフェードインさせる
     */
    setupPlainTextFlickering(){
        const textElements = document.querySelectorAll('.js-flickering_text');
        textElements.forEach(textElement => {
            const splitText = new SplitText(textElement, { type: "words,chars" });
            const chars = splitText.chars;

            // Shuffle the chars array
            this._shuffleArray(chars);

            // Initial setting to hide elements before animation
            gsap.set(chars, {opacity: 0, filter: 'brightness(1.5)'});

            // Set up ScrollTrigger
            ScrollTrigger.create({
                trigger: textElement,
                start: 'top 85%',
                onEnter: () => this._animateText(chars),
                once: true
            });
        });
    }

    _init() {
        this._observeFlickeringSvg();
        this.setupPlainTextFlickering();
    }

    /**
     * ランダムなディレイでフェードインアニメーションを適用。
     * @param {HTMLElement} elm - 対象の要素。
     */
    _animateElmFlicker(elm) {
        const delay = Math.random() * 0.55; // ランダムなディレイ（0から0.55秒）

        gsap.to(elm, {
            duration: 0.1, opacity: 1, ease: 'power2.inOut', delay: delay,
            onComplete: () => {
                gsap.to(elm, { duration: 0.1, ease: 'power2.inOut', filter: 'brightness(1)' });
            }
        });
    }

    /**
     * js-flickering_svgクラスが付いた要素をobservし、ビューポートに入ったときにアニメーションを開始する
     */
    _observeFlickeringSvg() {
        const elements = document.querySelectorAll('.js-flickering_svg');
        elements.forEach(element => {
            ScrollTrigger.create({
                trigger: element,
                start: 'top 85%',
                onEnter: () => this.setupSvgFlickering(element),
                once: true
            });
        });
    }

    /**
     * テキストに対してアニメーションを開始するメソッド
     * @param {HTMLElement[]} chars - アニメーションを適用するテキストの文字要素
     */
    _animateText(chars) {
        chars.forEach(char => {
            this._animateElmFlicker(char);
        });
    }

    /**
     * 任意のSVG要素に対してアニメーションを開始するメソッド
     * @param {HTMLElement} element - アニメーションを適用するSVG要素
     */
    startSvgFlickering(element) {
        this.setupSvgFlickering(element);
    }

    /**
     * 配列をランダムにシャッフルするヘルパー関数
     * @param {Array} array - シャッフルする配列
     */
    _shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
    }
}
